import { AuditLog } from 'api/Clients/Types/AuditLog'
import { NameDto } from 'api/Common/Types'
import { PageData } from 'api/Pagination/Types'
import { PaymentMethodReplyDto } from 'api/PaymentProvider/Types/PaymentMethodReplyDto'
import { PaymentProviderResponse } from 'api/PaymentProvider/Types/PaymentProviderFields'
import {
  CreatePaymentProviderGroupDto,
  PaymentProviderGroupDto,
  PaymentProviderOptionDto,
  UpdatePaymentProviderGroupDto,
} from 'api/PaymentProvider/Types/PaymentProviderGroupDto'
import {
  CreatePaymentProviderThresholdDto,
  PaymentProviderThresholdDto,
  UpdatePaymentProviderThresholdDto,
} from 'api/PaymentProvider/Types/PaymentProviderThresholdDto'
import { CreateTradingAccountBalanceConversionTransaction } from 'api/Trading-Accounts/Types/CreateTradingAccountBalanceConversionTransaction'
import { AdjustmentTransactionDto } from 'api/Transaction/Types/AdjustmentTransactionDto'
import { BonusTransactionDto } from 'api/Transaction/Types/BonusTransactionDto'
import { BonusType } from 'api/Transaction/Types/BonusType'
import { ComplexTransfer } from 'api/Transaction/Types/ComplexTransfer'
import { CreateBonusTransaction } from 'api/Transaction/Types/CreateBonusTransaction'
import { CreateTransactionNote } from 'api/Transaction/Types/CreateTransactionNote'
import { DepositToWalletByPspTransaction } from 'api/Transaction/Types/DepositToWalletByPspTransaction'
import { MasterTransactionDto } from 'api/Transaction/Types/MasterTransactionDto'
import { PaymentAgentDepositTransaction } from 'api/Transaction/Types/PaymentAgentDepositTransaction'
import { PaymentAgentWithdrawalTransaction } from 'api/Transaction/Types/PaymentAgentWithdrawalTransaction'
import { RawTransactionDto } from 'api/Transaction/Types/RawTransactionDto'
import { ReduceBonusReserved } from 'api/Transaction/Types/ReduceBonusReserved'
import { ReverseTransactionData } from 'api/Transaction/Types/ReverseTransactionData'
import { TransactionDto } from 'api/Transaction/Types/Transaction'
import { TransactionDirectionType } from 'api/Transaction/Types/TransactionDirectionType'
import { TransactionLimitDto } from 'api/Transaction/Types/TransactionLimitDto'
import { TransactionNoteDto } from 'api/Transaction/Types/TransactionNoteDto'
import { TransactionsState } from 'api/Transaction/Types/TransactionsState'
import { TransactionsStatusReason } from 'api/Transaction/Types/TransactionsStatusReason'
import { TransactionStateHistoryDto } from 'api/Transaction/Types/TransactionStateHistoryDto'
import { UpdateBonusTransaction } from 'api/Transaction/Types/UpdateBonusTransaction'
import { UpdateDepositWithdrawalMasterTransaction } from 'api/Transaction/Types/UpdateDepositWithdrawalMasterTransaction'
import { UpdateTransactionNote } from 'api/Transaction/Types/UpdateTransactionNote'
import { UpdateTransactionStatus } from 'api/Transaction/Types/UpdateTransactionStatus'
import { WithdrawalFromWalletPspTransaction } from 'api/Transaction/Types/WithdrawalFromWalletPspTransaction'
import {
  AggregateClientData,
  AggregateClientDataWithTotal,
} from 'api/Wallet/Types/AggregateClientData'
import {
  ApplyWalletRestrictionsByTradingAccountsResponseDto,
  VerifyWalletRestrictionsByTradingAccountsResponseDto,
} from 'api/Wallet/Types/BulkRestrictionsDto'
import { ClientPaymentProviderTransactionDto } from 'api/Wallet/Types/ClientPaymentProviderTransactionDto'
import { CreatePaymentAgentProfile } from 'api/Wallet/Types/CreatePaymentAgentProfile'
import { CreateRefundTransferToTradingAccount } from 'api/Wallet/Types/CreateRefundTransferToTradingAccount'
import { CreateWalletDto } from 'api/Wallet/Types/CreateWalletDto'
import { ManualMarginBonusOutRequest } from 'api/Wallet/Types/ManualMarginBonusOutRequest'
import { MLRunsDto } from 'api/Wallet/Types/MLRunsDto'
import { PaymentAgentDto } from 'api/Wallet/Types/PaymentAgentDto'
import { PaymentProviderDto } from 'api/Wallet/Types/PaymentProviderDto'
import { RestrictionDto } from 'api/Wallet/Types/RestrictionDto'
import { TradingAccountToWalletTransfer } from 'api/Wallet/Types/TradingAccountToWalletTransfer'
import { TransactionAdjustmentPreviewUpload } from 'api/Wallet/Types/TransactionAdjustmentPreviewUpload'
import { TransactionAdjustmentUploadHistory } from 'api/Wallet/Types/TransactionAdjustmentUploadHistory'
import { TransactionTypeDto } from 'api/Wallet/Types/TransactionTypeDto'
import { TransactionValidationsDto } from 'api/Wallet/Types/TransactionValidations'
import { UpdatePaymentAgent } from 'api/Wallet/Types/UpdatePaymentAgent'
import { UpdatePaymentAgentProfile } from 'api/Wallet/Types/UpdatePaymentAgentProfile'
import { UpdateWallet } from 'api/Wallet/Types/UpdateWallet'
import { UpdateWalletComplexTransfer } from 'api/Wallet/Types/UpdateWalletComplexTransfer'
import { UpdateWalletDepositWithdrawalTransfer } from 'api/Wallet/Types/UpdateWalletDepositWithdrawalTransfer'
import { UpdateWalletTradingAccountTransfer } from 'api/Wallet/Types/UpdateWalletTradingAccountTransfer'
import { UploadFileHistoryOverviewDto } from 'api/Wallet/Types/UploadFileHistoryOverviewDto'
import { WalletDto } from 'api/Wallet/Types/Wallet'
import { WalletConfigDto } from 'api/Wallet/Types/WalletConfigDto'
import { WalletCurrencyDto } from 'api/Wallet/Types/WalletCurrencyDto'
import { WalletPaymentAgentMethodDto } from 'api/Wallet/Types/WalletPaymentAgentMethodDto'
import { WalletStates } from 'api/Wallet/Types/WalletStates'
import { WalletToTradingAccountTransfer } from 'api/Wallet/Types/WalletToTradingAccountTransfer'
import {
  ConversionWalletToWalletTransferDto,
  WalletToWalletTransfer,
} from 'api/Wallet/Types/WalletToWalletTransfer'
import { WalletTypeDto } from 'api/Wallet/Types/WalletTypeDto'
import {
  AmountOverrideDto,
  AmountOverridePayload,
  DisableOverrideDto,
  DisableOverridePayload,
  OverrideEnabledPayload,
  WithdrawalAutomationGlobalSettingsDto,
  WithdrawalAutomationGlobalSettingsPayload,
  WithdrawalAutomationMasterEnabledPayload,
} from 'api/Wallet/Types/WithdrawalAutomationDto'
import { AxiosResponse } from 'axios'
import { AdjustmentTradingAccountFormValues } from 'routes/Transactions/Create/Adjustment/AdjustmentTradingAccountForm'

import {
  InterestRateConfigDto,
  InterestRateDto,
  InterestRateEligibilityCriteriaDto,
  InterestRateEligibilityCriteriaTypeDto,
  InterestRateThresholdDto,
} from '../../api/Interest-Rates/InterestRateDto'
import {
  BonusCampaignAvailabilityPeriod,
  BonusCampaignCountdownTrigger,
  BonusCampaignExcludeType,
  BonusLabel,
} from '../../api/Wallet/Types/BonusCampaignTypes'
import { BulkWithdrawalsOverviewDto } from '../../api/Wallet/Types/BulkWithdrawalsOverviewDto'
import {
  PspWdCheckPaymentOptionsDto,
  WalletPaymentProviderOptionDto,
} from '../../api/Wallet/Types/FullPaymentProviderDto'
import {
  AddCampaignDetailsFormValues,
  BonusCampaignCountryDto,
  BonusCampaignCountryFormValues,
  BonusCampaignCountryFormValuesEdit,
  BonusCampaignsDto,
  EditCampaignDetailsFormValues,
} from '../../api/Wallet/Types/MarketingBonusCampaignDto'
import { TransactionStateDto } from '../../api/Wallet/Types/TransactionStateDto'
import { AddInterestRateEligibilityFormValues } from '../../routes/Administration/InterestRates/AddInterestRateEligibilityForm'
import { AddInterestRateFormValues } from '../../routes/Administration/InterestRates/AddInterestRateForm'
import { AddInterestRateThresholdFormValues } from '../../routes/Administration/InterestRates/AddInterestRateThresholdForm'
import { EditInterestRateEligibilityFormValues } from '../../routes/Administration/InterestRates/EditInterestRateEligibilityForm'
import { EditInterestRateFormValues } from '../../routes/Administration/InterestRates/EditInterestRateForm'
import { EditInterestRateThresholdFormValues } from '../../routes/Administration/InterestRates/EditInterestRateThresholdForm'
import { getUriToUpdateFromStatusId, TransactionStatus } from '../transaction/status.index'
import { ApiClient } from './ApiClient'
import { PageQuery, preparePageQueryParams } from './index'
import { createLanguageQueryString } from './queryStringUtils'

export class WalletsApiClient {
  constructor(private apiClient: ApiClient) {}

  getWallets: (query?: PageQuery) => Promise<PageData<WalletDto[]>> = (query) => {
    return this.apiClient.get(`wallets/wallets?${preparePageQueryParams(query)}`)
  }
  getWalletsQuery: (
    query: string | null,
    pageIndex?: number,
    pageSize?: number
  ) => Promise<PageData<WalletDto[]>> = (query, pageIndex = 1, pageSize = 100) => {
    let url
    if (!query) {
      url = `wallets/wallets?PageIndex=${pageIndex}&PageSize=${pageSize}`
    } else {
      url = `wallets/wallets?Search=${query}&PageIndex=${pageIndex}&PageSize=${pageSize}`
    }
    return this.apiClient.get(url)
  }
  updateWallet: (id: string, data: UpdateWallet) => Promise<void> = (id, data) => {
    return this.apiClient.put(`wallets/wallets/${id}`, data)
  }
  getPaymentAgentsAll: () => Promise<PaymentAgentDto[]> = () => {
    return this.apiClient.get(`wallets/payment-agents/all`)
  }
  getPaymentAgents: (query?: PageQuery) => Promise<PageData<PaymentAgentDto[]>> = (query) => {
    return this.apiClient.get(`wallets/payment-agents?${preparePageQueryParams(query)}`)
  }
  getPaymentAgentsByClientId: (clientId: string) => Promise<WalletPaymentAgentMethodDto[]> = (
    clientId: string
  ) => {
    return this.apiClient.get(`wallets/payment-agents/clients/${clientId}/methods`)
  }
  getPaymentAgentsClientQuery: (
    query: string,
    pageIndex?: number,
    pageSize?: number
  ) => Promise<PageData<PaymentAgentDto[]>> = (query, pageIndex = 1, pageSize = 100) => {
    const url = `wallets/payment-agents/clients?Search=${query}&PageIndex=${pageIndex}&PageSize=${pageSize}`
    return this.apiClient.get(url)
  }
  getPaymentAgentById: (id: string) => Promise<PaymentAgentDto> = (id) => {
    return this.apiClient.get(`wallets/payment-agents/${id}`)
  }

  getInterestRates: (clientId: string, query?: PageQuery) => Promise<PageData<InterestRateDto[]>> =
    (clientId: string, query) => {
      return this.apiClient.get(
        `wallets/interest-rates/clients/${clientId}/daily-accruals?${preparePageQueryParams(query)}`
      )
    }
  updatePaymentAgent: (data: UpdatePaymentAgent) => Promise<PaymentAgentDto> = (data) => {
    return this.apiClient.put(`wallets/payment-agents/${data.id}`, data)
  }
  createPaymentAgentProfile: (data: CreatePaymentAgentProfile) => Promise<void> = (data) => {
    return this.apiClient.post(`wallets/payment-agents/${data.paymentAgentId}/profiles`, data)
  }
  updatePaymentAgentProfile: (data: UpdatePaymentAgentProfile) => Promise<void> = (data) => {
    return this.apiClient.put(`wallets/payment-agents/profiles/${data.id}`, data)
  }
  deletePaymentAgentProfile: (id: string) => Promise<void> = (id) => {
    return this.apiClient.delete(`wallets/payment-agents/profiles/${id}`)
  }
  getPaymentAgentEvents: (id: string) => Promise<AuditLog[]> = (id) => {
    return this.apiClient.get(`wallets/payment-agents/${id}/events`)
  }
  getWalletEvents: (id: string) => Promise<AuditLog[]> = (id) => {
    return this.apiClient.get(`wallets/wallets/${id}/events`)
  }
  getPSPEvents: (id: string) => Promise<AuditLog[]> = (id) => {
    return this.apiClient.get(`wallets/payment-providers/${id}/events`)
  }
  getPSPGroupEvents: (id: string) => Promise<AuditLog[]> = (id) => {
    return this.apiClient.get(`wallets/payment-providers/groups/${id}/events`)
  }
  acceptPaymentAgentClientPOA: (paymentAgentId: string, clientId: string) => Promise<void> = (
    paymentAgentId,
    clientId
  ) => {
    return this.apiClient.post(`wallets/payment-agents/${paymentAgentId}/clients/${clientId}`, {})
  }
  getTransactions: (
    type: 'adjustments' | 'deposit-withdrawals' | 'wallet-transfers' | 'payment-agent-transfers',
    query?: PageQuery
  ) => Promise<PageData<TransactionDto[]>> = (type, query) => {
    return this.apiClient.get(`wallets/transactions/${type}?${preparePageQueryParams(query)}`)
  }
  getIBCommissionsTransactions: (query?: PageQuery) => Promise<PageData<TransactionDto[]>> = (
    query
  ) => {
    return this.apiClient.get(
      `wallets/transactions/adjustments/overview?${preparePageQueryParams(query)}`
    )
  }
  getTradingAccountAdjustmentTransactions: (
    query?: PageQuery
  ) => Promise<PageData<TransactionDto[]>> = (query) => {
    return this.apiClient.get(
      `wallets/transactions/ta-adjustments/overview?${preparePageQueryParams(query)}`
    )
  }
  getPlatformTransferTransactions: (
    query?: PageQuery
  ) => Promise<PageData<AdjustmentTransactionDto[]>> = (query) => {
    return this.apiClient.get(
      `wallets/transactions/platform-transfers?${preparePageQueryParams(query)}`
    )
  }
  getPlatformTransactionByTradingAccountId: (
    tradingAccountId: string,
    query?: PageQuery
  ) => Promise<PageData<AdjustmentTransactionDto[]>> = (tradingAccountId, query) => {
    return this.apiClient.get(
      `wallets/trading-accounts/${tradingAccountId}/transactions?${preparePageQueryParams(query)}`
    )
  }
  getBonusTransactions: (query?: PageQuery) => Promise<PageData<BonusTransactionDto[]>> = (
    query
  ) => {
    return this.apiClient.get(
      `wallets/transactions/bonus/overview?${preparePageQueryParams(query)}`
    )
  }
  getFileUploadHistoryTransactions: (
    query?: PageQuery
  ) => Promise<PageData<UploadFileHistoryOverviewDto[]>> = (query) => {
    return this.apiClient.get(
      `wallets/transactions/upload/history?${preparePageQueryParams(query)}`
    )
  }
  getBulkWithdrawalsTransactions: (
    query?: PageQuery
  ) => Promise<PageData<BulkWithdrawalsOverviewDto[]>> = (query) => {
    return this.apiClient.get(
      `wallets/transactions/group-references?${preparePageQueryParams(query)}`
    )
  }
  getTransactionById: (id: string) => Promise<TransactionDto> = (id) => {
    return this.apiClient.get(`wallets/transactions/${id}`)
  }
  getTransactionNotesByClientId: (id: string) => Promise<TransactionNoteDto[]> = (id) => {
    return this.apiClient.get(`wallets/transactions/notes/clients/${id}`)
  }
  getTransactionNotesByTransactionId: (id: string) => Promise<TransactionNoteDto[]> = (id) => {
    return this.apiClient.get(`wallets/transactions/${id}/notes`)
  }
  updateBonusTransaction: (data: UpdateBonusTransaction, id: string) => Promise<void> = (
    data,
    id
  ) => {
    return this.apiClient.put(`wallets/transactions/bonus/${id}`, data)
  }
  addTransactionNote: (data: CreateTransactionNote) => Promise<void> = (data) => {
    return this.apiClient.post(`wallets/transactions/notes`, data)
  }
  updateTransactionNote: (data: UpdateTransactionNote) => Promise<void> = (data) => {
    return this.apiClient.put(`wallets/transactions/notes/${data.id}`, data)
  }
  removeTransactionNoteById: (id: string) => Promise<void> = (id) => {
    return this.apiClient.delete(`wallets/transactions/notes/${id}`)
  }
  getPaymentProviderTransaction: (id: string) => Promise<ClientPaymentProviderTransactionDto[]> = (
    id
  ) => {
    return this.apiClient.get(`wallets/transactions/clients/${id}/payment-provider-transactions`)
  }
  getClientWallet: (id: string) => Promise<WalletDto[]> = (id) => {
    return this.apiClient.get(`wallets/wallets/clients/${id}`)
  }
  getClientAggregatedDataQuery: (
    clientId: string,
    query: string
  ) => Promise<AggregateClientData[]> = (clientId, query) => {
    const url = query
      ? `wallets/wallets/clients/${clientId}/aggregated-data?${query}`
      : `wallets/wallets/clients/${clientId}/aggregated-data`
    return this.apiClient.get(url)
  }
  getClientAggregatedDataTotalQuery: (
    clientId: string,
    query: PageQuery
  ) => Promise<AggregateClientDataWithTotal> = (clientId, query) => {
    return this.apiClient.get(
      `wallets/wallets/clients/${clientId}/aggregated-data-total?${preparePageQueryParams(query)}`
    )
  }
  getWalletById: (id: string) => Promise<WalletDto> = (id) => {
    return this.apiClient.get(`wallets/wallets/${id}`)
  }
  getWalletTransactions: (
    walletId: string,
    query?: PageQuery
  ) => Promise<PageData<RawTransactionDto[]>> = (walletId, query) => {
    return this.apiClient.get(
      `wallets/wallets/${walletId}/transactions?${preparePageQueryParams(query)}`
    )
  }
  createWalletToWalletTransfer: (
    data: WalletToWalletTransfer | ConversionWalletToWalletTransferDto
  ) => Promise<TransactionDto> = (data) => {
    return this.apiClient.post(`wallets/transactions/transfer`, data)
  }
  createPaymentAgentWithdrawTransaction: (
    data: PaymentAgentWithdrawalTransaction
  ) => Promise<TransactionDto> = (data) => {
    return this.apiClient.post(`wallets/transactions/withdraw-to-payment-agent`, data)
  }
  createPaymentAgentDepositTransactionForClient: (
    data: PaymentAgentDepositTransaction
  ) => Promise<TransactionDto> = (data) => {
    return this.apiClient.post(`wallets/transactions/deposit-from-payment-agent`, data)
  }
  createWalletToTradingAccountTransfer: (
    data: WalletToTradingAccountTransfer
  ) => Promise<AxiosResponse<TransactionDto>> = (data) => {
    return this.apiClient.fetch(`wallets/transactions/transfer-to-trading-account`, {
      data,
      method: 'POST',
    })
  }
  updateWalletToTradingAccountTransfer: (
    data: UpdateWalletTradingAccountTransfer,
    typeId: number
  ) => Promise<AxiosResponse<TransactionDto>> = (data, typeId) => {
    const type = typeId === 400 ? 'transfer-from-trading-account' : 'transfer-to-trading-account'
    return this.apiClient.put(`wallets/transactions/${type}/${data.transactionId}`, data)
  }
  updateWalletComplexTransfer: (data: UpdateWalletComplexTransfer) => Promise<void> = (data) => {
    return this.apiClient.put(`wallets/transactions/complex-transfer/${data.transactionId}`, data)
  }
  updateWalletDepositWithdrawalTransfer: (
    transactionId: string,
    data: UpdateWalletDepositWithdrawalTransfer,
    type: 'deposit' | 'withdraw'
  ) => Promise<void> = (transactionId, data, type) => {
    return this.apiClient.put(`wallets/transactions/${transactionId}/${type}`, data)
  }
  createTradingAccountToWalletTransfer: (
    data: TradingAccountToWalletTransfer
  ) => Promise<AxiosResponse<TransactionDto>> = (data) => {
    return this.apiClient.fetch(`wallets/transactions/transfer-from-trading-account`, {
      data,
      method: 'POST',
    })
  }
  createListOfSingleWalletTransfer: (data: ComplexTransfer) => Promise<TransactionDto> = (data) => {
    return this.apiClient.post(`wallets/transactions/complex-transfer`, data)
  }
  createTradingAccountAdjustment: (
    data: AdjustmentTradingAccountFormValues
  ) => Promise<AxiosResponse<TransactionDto>> = (data) => {
    return this.apiClient.fetch(`wallets/transactions/trading-account-adjustment`, {
      data,
      method: 'POST',
    })
  }
  uploadTradingAccountAdjustmentPreview: (
    formData: FormData
  ) => Promise<TransactionAdjustmentPreviewUpload[]> = (data) => {
    return this.apiClient.upload(
      'POST',
      `wallets/transactions/upload/trading-account-adjustments/preview`,
      data
    )
  }
  uploadTradingAccountAdjustmentFile: (
    formData: FormData
  ) => Promise<{ uploadFileHistoryId: string }> = (data) => {
    return this.apiClient.upload(
      'POST',
      `wallets/transactions/upload/trading-account-adjustments`,
      data
    )
  }
  getTradingAccountAdjustmentHistoryUpload: (
    id: string
  ) => Promise<TransactionAdjustmentUploadHistory> = (id) => {
    return this.apiClient.get(`wallets/transactions/upload/history/${id}`)
  }
  linkTransaction: (
    sourceTransactionId: string,
    targetTransactionId: string,
    linkTypeId: number
  ) => Promise<void> = (sourceTransactionId, targetTransactionId, linkTypeId) => {
    return this.apiClient.post(
      `wallets/transactions/${sourceTransactionId}/link-to/${targetTransactionId}/link-type/${linkTypeId}`,
      {}
    )
  }
  createDepositToWalletByPspTransaction: (
    data: DepositToWalletByPspTransaction
  ) => Promise<AxiosResponse<TransactionDto>> = (data) => {
    return this.apiClient.fetch(`wallets/transactions/deposit`, { data, method: 'POST' })
  }
  createWithdrawalFromWalletByPspTransaction: (
    data: WithdrawalFromWalletPspTransaction
  ) => Promise<AxiosResponse<TransactionDto>> = (data) => {
    return this.apiClient.fetch(`wallets/transactions/withdraw`, { data, method: 'POST' })
  }
  reverseCompletedTransaction: (data: ReverseTransactionData) => Promise<void> = (data) => {
    return this.apiClient.post(`wallets/transactions/reverse`, data)
  }
  createBonusTransactions: (
    data: CreateBonusTransaction
  ) => Promise<AxiosResponse<TransactionDto>> = (data) => {
    return this.apiClient.fetch(`wallets/transactions/bonus`, { data, method: 'POST' })
  }
  getWalletState: () => Promise<WalletStates[]> = () => {
    return this.apiClient.get(`wallets/wallets/wallet-states`)
  }
  getWalletTypes: () => Promise<WalletTypeDto[]> = () => {
    return this.apiClient.get(`wallets/wallets/wallet-types`)
  }

  getSocialMediaTypes: () => Promise<WalletTypeDto[]> = () => {
    return this.apiClient.get(`wallets/payment-agents/social-media-types`)
  }
  getWalletCurrencies: () => Promise<WalletCurrencyDto[]> = () => {
    return this.apiClient.get(`wallets/currencies`)
  }
  getWalletTypesByClientId: (id: string) => Promise<WalletTypeDto[]> = (id) => {
    return this.apiClient.get(`wallets/wallets/clients/${id}/wallet-types`)
  }
  getWalletTransactionsByClientId: (
    clientId: string,
    query?: PageQuery
  ) => Promise<PageData<RawTransactionDto[]>> = (clientId, query) => {
    return this.apiClient.get(
      `wallets/wallets/clients/${clientId}/transactions?${preparePageQueryParams(query)}`
    )
  }
  getWalletPaymentProviders: () => Promise<PaymentProviderDto[]> = () => {
    return this.apiClient.get(`wallets/payment-providers`)
  }
  getWalletRestrictions: () => Promise<RestrictionDto[]> = () => {
    return this.apiClient.get(`wallets/wallets/restriction-types`)
  }
  previewWalletRestrictionsByTradingAccounts: (
    formData: FormData
  ) => Promise<VerifyWalletRestrictionsByTradingAccountsResponseDto> = (data) => {
    return this.apiClient.upload(
      'POST',
      `wallets/brokerage-restrictions/apply-wallet-restrictions/preview`,
      data
    )
  }
  applyWalletRestrictionsByTradingAccounts: (
    formData: FormData
  ) => Promise<ApplyWalletRestrictionsByTradingAccountsResponseDto> = (data) => {
    return this.apiClient.upload(
      'POST',
      `wallets/brokerage-restrictions/apply-wallet-restrictions`,
      data
    )
  }
  getWalletAvailableCurrencies: (
    preferredEntityId: number,
    walletTypeId?: number
  ) => Promise<WalletCurrencyDto[]> = (preferredEntityId, walletTypeId = 1) => {
    return this.apiClient.get(
      `wallets/wallets/available-currencies?tickmillCompanyId=${preferredEntityId}&walletTypeId=${walletTypeId}`
    )
  }
  getAvailableCurrenciesForClient: ({
    clientId,
    walletTypeId,
  }: {
    clientId: string
    walletTypeId: number
  }) => Promise<WalletCurrencyDto[]> = ({ clientId, walletTypeId }) => {
    return this.apiClient.get(
      `wallets/wallets/clients/${clientId}/wallet-types/${walletTypeId}/available-currencies`
    )
  }
  getWalletsConfig: (query?: PageQuery) => Promise<PageData<WalletConfigDto[]>> = (query) => {
    return this.apiClient.get(`wallets/wallets/config?${preparePageQueryParams(query)}`)
  }
  getWalletConfig: (
    clientId: string,
    query?: PageQuery
  ) => Promise<{ id: string; name: string }[]> = (
    clientId,
    query,
    walletType = 1 // FX/CFD
  ) => {
    return this.apiClient.get(
      `wallets/wallets/clients/${clientId}/wallet-types/${walletType}/available-currencies?${new URLSearchParams(
        query
      )}`
    )
  }
  createWallet: (data: CreateWalletDto) => Promise<AxiosResponse<WalletDto>> = (data) => {
    return this.apiClient.fetch(`wallets/wallets`, { data, method: 'POST' })
  }
  getTransactionStatus: () => Promise<TransactionsState[]> = () => {
    return this.apiClient.get(`wallets/transactions/states`)
  }
  getTransactionByIdStatus: (transactionId: string) => Promise<TransactionStateDto[]> = (
    transactionId
  ) => {
    return this.apiClient.get(`wallets/transactions/${transactionId}/states`)
  }
  getTransactionReasonsStatus: (transactionTypeId?: number) => Promise<TransactionsStatusReason[]> =
    (transactionTypeId) => {
      if (transactionTypeId) {
        return this.apiClient.get(
          `wallets/transactions/transaction-state-reasons?transactionTypeId=${transactionTypeId}`
        )
      }
      return this.apiClient.get(`wallets/transactions/transaction-state-reasons`)
    }
  updateTransactionStatus: (
    statusId: TransactionStatus,
    data: UpdateTransactionStatus
  ) => Promise<TransactionsStatusReason[]> = (statusId, data) => {
    const uri = getUriToUpdateFromStatusId(statusId)
    if (!uri) {
      return new Promise((_resolve, reject) => {
        reject('Not endpoint for status with id:' + statusId)
      })
    }
    return this.apiClient.post(`wallets/transactions/${uri}`, data)
  }
  getTransactionStatusHistory: (id: string) => Promise<TransactionStateHistoryDto> = (id) => {
    return this.apiClient.get(`wallets/transactions/${id}/transaction-state-history`)
  }
  createRefundTransferToTradingAccount: (
    data: CreateRefundTransferToTradingAccount
  ) => Promise<void> = (data) => {
    return this.apiClient.post(`wallets/transactions/trading-account-adjustment`, data)
  }
  getTransactionAuditLogs: (id: string) => Promise<AuditLog[]> = (id) => {
    return this.apiClient.get(`wallets/transactions/${id}/events`)
  }
  removePaymentAgent: (paymentAgentId: string, clientId: string) => Promise<void> = (
    paymentAgentId,
    clientId
  ) => {
    return this.apiClient.delete(`wallets/payment-agents/${paymentAgentId}/clients/${clientId}`)
  }
  getWalletsByClientId: (id: string) => Promise<WalletDto[]> = (id) => {
    return this.apiClient.get(`wallets/wallets/clients/${id}`)
  }
  getBonusTransactionTypes: () => Promise<PageData<BonusType[]>> = () => {
    return this.apiClient.get(
      `/wallets/transactions/bonus-types?${preparePageQueryParams({
        pageSize: 100,
        pageIndex: 1,
      })}`
    )
  }
  getBonusTransactionStatuses: () => Promise<NameDto[]> = () => {
    return this.apiClient.get(`/wallets/transactions/bonus-transaction-statuses`)
  }
  reduceReservedTransactionBonuses: (
    transactionId: string,
    data: ReduceBonusReserved
  ) => Promise<MasterTransactionDto[]> = (transactionId, data) => {
    return this.apiClient.put(`/wallets/transactions/${transactionId}/reduce-bonus-reserved`, data)
  }
  cancelTransactionBonuses: (
    transactionId: string,
    walletTransactionId: string
  ) => Promise<MasterTransactionDto[]> = (transactionId, walletTransactionId) => {
    return this.apiClient.put(`/wallets/transactions/${transactionId}/cancel-bonus`, {
      walletTransactionId,
    })
  }
  getDirectionTypes: () => Promise<TransactionDirectionType[]> = () => {
    return this.apiClient.get(`/wallets/transactions/direction-types`)
  }
  getTransactionTypes: (query?: PageQuery) => Promise<TransactionTypeDto[]> = (query) => {
    return this.apiClient.get(`/wallets/transactions/types?${new URLSearchParams(query)}`)
  }
  getTransactionValidations: (transactionId?: string) => Promise<TransactionValidationsDto[]> = (
    transactionId
  ) => {
    return this.apiClient.get(`/wallets/transactions/${transactionId}/validations`)
  }
  getMlRuns: (masterTransactionId: string) => Promise<MLRunsDto[]> = (masterTransactionId) => {
    return this.apiClient.get(
      `/wallets/withdrawal-automation/ml-runs?${new URLSearchParams({
        MasterTransactionId: masterTransactionId,
      })}`
    )
  }
  getWithdrawalAutomationGlobalSettings: () => Promise<WithdrawalAutomationGlobalSettingsDto> =
    () => {
      return this.apiClient.get(`wallets/withdrawal-automation/global-settings`)
    }
  updateWithdrawalAutomationGlobalSettings: (
    data: WithdrawalAutomationGlobalSettingsPayload
  ) => Promise<void> = (data) => {
    return this.apiClient.put(`wallets/withdrawal-automation/global-settings`, data)
  }
  setWithdrawalAutomationMasterEnabled: (
    data: WithdrawalAutomationMasterEnabledPayload
  ) => Promise<void> = (data) => {
    return this.apiClient.put(`wallets/withdrawal-automation/global-settings/enable`, data)
  }
  getWithdrawalAutomationAmountOverrides: () => Promise<AmountOverrideDto[]> = () => {
    return this.apiClient.get(`wallets/withdrawal-automation/amount-overrides`)
  }
  getWithdrawalAutomationAmountOverrideById: (id: string) => Promise<AmountOverrideDto> = (id) => {
    return this.apiClient.get(`wallets/withdrawal-automation/amount-overrides/${id}`)
  }
  createWithdrawalAutomationAmountOverride: (data: AmountOverridePayload) => Promise<void> = (
    data
  ) => {
    return this.apiClient.post(`wallets/withdrawal-automation/amount-overrides`, data)
  }
  updateWithdrawalAutomationAmountOverride: (
    id: string,
    data: AmountOverridePayload
  ) => Promise<void> = (id, data) => {
    return this.apiClient.put(`wallets/withdrawal-automation/amount-overrides/${id}`, data)
  }
  setWithdrawalAutomationAmountOverrideEnabled: (
    id: string,
    data: OverrideEnabledPayload
  ) => Promise<void> = (id, data) => {
    return this.apiClient.put(`wallets/withdrawal-automation/amount-overrides/${id}/enable`, data)
  }
  deleteWithdrawalAutomationAmountOverride: (id: string) => Promise<void> = (id) => {
    return this.apiClient.delete(`wallets/withdrawal-automation/amount-overrides/${id}`)
  }
  getWithdrawalAutomationDisableOverrides: () => Promise<DisableOverrideDto[]> = () => {
    return this.apiClient.get(`wallets/withdrawal-automation/disable-overrides`)
  }
  getWithdrawalAutomationDisableOverrideById: (id: string) => Promise<DisableOverrideDto> = (
    id
  ) => {
    return this.apiClient.get(`wallets/withdrawal-automation/disable-overrides/${id}`)
  }
  createWithdrawalAutomationDisableOverride: (data: DisableOverridePayload) => Promise<void> = (
    data
  ) => {
    return this.apiClient.post(`wallets/withdrawal-automation/disable-overrides`, data)
  }
  updateWithdrawalAutomationDisableOverride: (
    id: string,
    data: DisableOverridePayload
  ) => Promise<void> = (id, data) => {
    return this.apiClient.put(`wallets/withdrawal-automation/disable-overrides/${id}`, data)
  }
  setWithdrawalAutomationDisableOverrideEnabled: (
    id: string,
    data: OverrideEnabledPayload
  ) => Promise<void> = (id, data) => {
    return this.apiClient.put(`wallets/withdrawal-automation/disable-overrides/${id}/enable`, data)
  }
  deleteWithdrawalAutomationDisableOverride: (id: string) => Promise<void> = (id) => {
    return this.apiClient.delete(`wallets/withdrawal-automation/disable-overrides/${id}`)
  }
  getPaymentProviderField: (
    type: 'deposits' | 'withdrawals',
    query: PageQuery
  ) => Promise<PaymentProviderResponse> = (type, query) => {
    return this.apiClient.get(
      `/wallets/payment-providers/methods/${type}/parameters?${preparePageQueryParams(query)}`
    )
  }
  getAvailablePaymentProviders: (
    type: 'deposits' | 'withdrawals',
    query: PageQuery
  ) => Promise<{ errors: string[]; reply: PaymentMethodReplyDto[] }> = (type, query) =>
    this.apiClient.get(
      `/wallets/payment-providers/methods/${type}?${preparePageQueryParams(query)}`
    )

  getPaymentProviders: (query?: PageQuery) => Promise<PageData<PspWdCheckPaymentOptionsDto[]>> = (
    query
  ) => {
    return this.apiClient.get(
      `wallets/payment-providers/browse/wd-check-options?${preparePageQueryParams(query)}`
    )
  }
  getPaymentProvider: (id: string) => Promise<PspWdCheckPaymentOptionsDto> = (id) => {
    return this.apiClient.get(`wallets/payment-providers/${id}/wd-check-options`)
  }
  updatePaymentProvider: (values: PspWdCheckPaymentOptionsDto) => Promise<void> = (values) => {
    return this.apiClient.put(
      `wallets/payment-providers/${values.paymentProvider.id}/wd-check-options`,
      values
    )
  }

  getPaymentProviderOptionsById: (
    paymentProviderId: string
  ) => Promise<WalletPaymentProviderOptionDto[]> = (paymentProviderId: string) => {
    return this.apiClient.get(
      `wallets/payment-providers/${paymentProviderId}/payment-provider-options`
    )
  }
  getAvailablePaymentProviderOptions: () => Promise<PaymentProviderOptionDto[]> = () => {
    return this.apiClient.get(
      `/wallets/payment-providers/groups/available-payment-provider-methods-for-amount-ratio`
    )
  }
  getPaymentProvidersGroups: (query?: PageQuery) => Promise<PageData<PaymentProviderGroupDto[]>> = (
    query
  ) => {
    return this.apiClient.get(`/wallets/payment-providers/groups?${preparePageQueryParams(query)}`)
  }
  updatePaymentProvidersGroup: (
    pspGroupId: string,
    data: UpdatePaymentProviderGroupDto
  ) => Promise<void> = (pspGroupId, data) => {
    return this.apiClient.put(`/wallets/payment-providers/groups/${pspGroupId}`, data)
  }
  createPaymentProvidersGroup: (data: CreatePaymentProviderGroupDto) => Promise<void> = (data) => {
    return this.apiClient.post(`/wallets/payment-providers/groups`, data)
  }
  removePaymentProvidersGroup: (pspGroupId: string) => Promise<void> = (pspGroupId) => {
    return this.apiClient.delete(`/wallets/payment-providers/groups/${pspGroupId}`)
  }
  addInterestRatesConfig: (data: AddInterestRateFormValues) => Promise<void> = (data) => {
    return this.apiClient.post(`wallets/interest-rates/config`, data)
  }
  getInterestRatesConfig: (query?: PageQuery) => Promise<PageData<InterestRateConfigDto[]>> = (
    query
  ) => {
    return this.apiClient.get(`wallets/interest-rates/config?${preparePageQueryParams(query)}`)
  }
  updateInterestRatesConfig: (data: EditInterestRateFormValues) => Promise<InterestRateConfigDto> =
    (data) => {
      return this.apiClient.put(`wallets/interest-rates/config/${data.id}`, data)
    }
  deleteInterestRatesConfig: (id: string) => Promise<void> = (id) => {
    return this.apiClient.delete(`wallets/interest-rates/config/${id}`)
  }
  addInterestRatesThresholds: (data: AddInterestRateThresholdFormValues) => Promise<void> = (
    data
  ) => {
    return this.apiClient.post(`wallets/interest-rates/thresholds`, data)
  }
  getInterestRatesThresholds: (query?: PageQuery) => Promise<PageData<InterestRateThresholdDto[]>> =
    (query) => {
      return this.apiClient.get(
        `wallets/interest-rates/thresholds?${preparePageQueryParams(query)}`
      )
    }
  updateInterestRatesThresholds: (
    data: EditInterestRateThresholdFormValues
  ) => Promise<InterestRateThresholdDto> = (data) => {
    return this.apiClient.put(`wallets/interest-rates/thresholds/${data.id}`, data)
  }
  deleteInterestRatesThresholds: (id: string) => Promise<void> = (id) => {
    return this.apiClient.delete(`wallets/interest-rates/thresholds/${id}`)
  }
  getPaymentProviderThresholds: (
    query?: PageQuery
  ) => Promise<PageData<PaymentProviderThresholdDto[]>> = (query) => {
    return this.apiClient.get(
      `wallets/payment-providers/thresholds?${preparePageQueryParams(query)}`
    )
  }
  addPaymentProviderThreshold: (data: CreatePaymentProviderThresholdDto) => Promise<void> = (
    data
  ) => {
    return this.apiClient.post(`wallets/payment-providers/thresholds`, data)
  }
  updatePaymentProviderThreshold: (
    id: string,
    data: UpdatePaymentProviderThresholdDto
  ) => Promise<void> = (id, data) => {
    return this.apiClient.put(`wallets/payment-providers/thresholds/${id}`, data)
  }
  deletePaymentProviderThreshold: (id: string) => Promise<void> = (id) => {
    return this.apiClient.delete(`wallets/payment-providers/thresholds/${id}`)
  }
  getPaymentProviderThresholdEvents: (id: string) => Promise<AuditLog[]> = (id) => {
    return this.apiClient.get(`wallets/payment-providers/thresholds/${id}/events`)
  }
  addInterestRatesEligibility: (data: AddInterestRateEligibilityFormValues) => Promise<void> = (
    data
  ) => {
    return this.apiClient.post(`wallets/interest-rates/eligibility-criteria`, data)
  }
  getInterestRatesEligibilityCriteriaTypes: () => Promise<
    InterestRateEligibilityCriteriaTypeDto[]
  > = () => {
    return this.apiClient.get(`wallets/interest-rates/eligibility-criteria-types`)
  }
  getInterestRatesEligibility: (
    query?: PageQuery
  ) => Promise<PageData<InterestRateEligibilityCriteriaDto[]>> = (query) => {
    return this.apiClient.get(
      `wallets/interest-rates/eligibility-criteria?${preparePageQueryParams(query)}`
    )
  }
  updateInterestRatesEligibility: (
    data: EditInterestRateEligibilityFormValues
  ) => Promise<InterestRateEligibilityCriteriaDto> = (data) => {
    return this.apiClient.put(`wallets/interest-rates/eligibility-criteria/${data.id}`, data)
  }
  deleteInterestRatesEligibility: (id: string) => Promise<void> = (id) => {
    return this.apiClient.delete(`wallets/interest-rates/eligibility-criteria/${id}`)
  }

  getTransactionLimits: () => Promise<TransactionLimitDto[]> = () => {
    return this.apiClient.get<TransactionLimitDto[]>(`/wallets/transactions/limits/min`)
  }

  convertTradingAccountBalance: (
    values: CreateTradingAccountBalanceConversionTransaction
  ) => Promise<TransactionDto> = (values) => {
    return this.apiClient.post(`/wallets/transactions/trading-account-balance-conversion`, values)
  }

  getAllowedBonusTypes: () => Promise<NameDto[]> = () => {
    return this.apiClient.get(`wallets/bonus-campaigns/allowed-bonus-types`)
  }
  getBonusLabels: () => Promise<BonusLabel[]> = () => {
    return this.apiClient.get(`wallets/bonus-campaigns/bonus-labels`)
  }

  getBonusCampaignExcludeTypes: () => Promise<BonusCampaignExcludeType[]> = () => {
    return this.apiClient.get(`wallets/bonus-campaigns/bonus-campaign-exclude-types`)
  }

  getBonusCampaignAvailabilityPeriods: () => Promise<BonusCampaignAvailabilityPeriod[]> = () => {
    return this.apiClient.get(`wallets/bonus-campaigns/bonus-campaign-availability-periods`)
  }

  getBonusCampaignCountdownTriggers: () => Promise<BonusCampaignCountdownTrigger[]> = () => {
    return this.apiClient.get(`wallets/bonus-campaigns/bonus-campaign-countdown-triggers`)
  }

  getBonusCampaigns: (
    query?: PageQuery,
    languageId?: string
  ) => Promise<PageData<BonusCampaignsDto[]>> = (query, languageId = 'en') => {
    return this.apiClient.get(
      `wallets/bonus-campaigns?${preparePageQueryParams(query)}${createLanguageQueryString(languageId, true)}`
    )
  }

  getEnabledBonusCampaigns: (query?: PageQuery, languageId?: string) => Promise<NameDto[]> = () => {
    return this.apiClient.get(`wallets/bonus-campaigns/enabled`)
  }

  getBonusCampaignById: (id: string, languageId?: string) => Promise<BonusCampaignsDto> = (
    id,
    languageId = 'en'
  ) => {
    return this.apiClient.get(
      `wallets/bonus-campaigns/${id}?${createLanguageQueryString(languageId)}`
    )
  }
  getBonusCampaignEvents: (id: string) => Promise<AuditLog[]> = (id) => {
    return this.apiClient.get(`wallets/bonus-campaigns/${id}/events`)
  }
  getBonusCampaignCountries: (
    id: string,
    query?: PageQuery
  ) => Promise<PageData<BonusCampaignCountryDto[]>> = (id, query) => {
    return this.apiClient.get(
      `wallets/bonus-campaigns/${id}/country-options?${preparePageQueryParams(query)}`
    )
  }

  addBonusCampaignCountry: (id: string, data: BonusCampaignCountryFormValues) => Promise<void> = (
    id,
    data
  ) => {
    return this.apiClient.post(`wallets/bonus-campaigns/${id}/country-options`, data)
  }
  updateBonusCampaignCountry: (
    id: string,
    bonusCampaignCountryOptionId: string,
    data: BonusCampaignCountryFormValuesEdit
  ) => Promise<void> = (id, bonusCampaignCountryOptionId, data) => {
    return this.apiClient.put(
      `wallets/bonus-campaigns/${bonusCampaignCountryOptionId}/${id}/country-options`,
      data
    )
  }

  addBonusCampaign: (data: AddCampaignDetailsFormValues) => Promise<void> = (data) => {
    return this.apiClient.post(`wallets/bonus-campaigns`, data)
  }
  updateBonusCampaign: (id: string, data: EditCampaignDetailsFormValues) => Promise<void> = (
    id,
    data
  ) => {
    return this.apiClient.put(`wallets/bonus-campaigns/${id}`, data)
  }
  updateDepositWithdrawalMasterTransaction: (
    masterTransactionId: string,
    data: UpdateDepositWithdrawalMasterTransaction
  ) => Promise<void> = (masterTransactionId, data) => {
    return this.apiClient.put(
      `wallets/mgmt/master-transactions/${masterTransactionId}/update`,
      data
    )
  }

  manualMarginBonusOut: (data: ManualMarginBonusOutRequest) => Promise<void> = (data) => {
    return this.apiClient.post('wallets/transactions/margin-bonus-out', data)
  }
}
